export const getters = {
  payments: (state: any) => state.payments
}
